import api from './api';

export interface LandingPageIdea {
    _id: string;
    idea: string;
    pageType: 'founder' | 'agency';
    userId?: {
        _id: string;
        name: string;
        email: string;
    } | null;
    email?: string;
    ipAddress?: string;
    userAgent?: string;
    isProcessed: boolean;
    notes?: string;
    createdAt: string;
    updatedAt: string;
}

export interface AgencyRequest {
    _id: string;
    name: string;
    email: string;
    agencyName: string;
    userId?: {
        _id: string;
        name: string;
        email: string;
        role: string;
    } | null;
    ipAddress?: string;
    userAgent?: string;
    isProcessed: boolean;
    notes?: string;
    createdAt: string;
    updatedAt: string;
}

export interface PaginationData {
    currentPage: number;
    totalPages: number;
    totalIdeas?: number;
    totalRequests?: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
}

export interface FilterCounts {
    total: number;
    withUser: number;
    withoutUser: number;
    processed?: number;
    unprocessed: number;
}

const adminService = {
    // Get all landing page ideas
    getLandingPageIdeas: async (params: {
        page?: number;
        limit?: number;
        search?: string;
        pageType?: string;
        hasUser?: string;
        isProcessed?: string;
        sortBy?: string;
        sortOrder?: string;
    }) => {
        const response = await api.get('/admin/landing-page-ideas', { params });
        return response.data;
    },

    // Update idea status
    updateIdeaStatus: async (ideaId: string, data: { isProcessed: boolean; notes?: string }) => {
        const response = await api.put(`/admin/landing-page-ideas/${ideaId}/status`, data);
        return response.data;
    },

    // Get all agency requests
    getAgencyRequests: async (params: {
        page?: number;
        limit?: number;
        search?: string;
        hasUser?: string;
        isProcessed?: string;
        sortBy?: string;
        sortOrder?: string;
    }) => {
        const response = await api.get('/admin/agency-requests', { params });
        return response.data;
    },

    // Update agency request status
    updateAgencyRequestStatus: async (requestId: string, data: { isProcessed: boolean; notes?: string }) => {
        const response = await api.put(`/admin/agency-requests/${requestId}/status`, data);
        return response.data;
    },
};

export default adminService;
